import { generateClient } from 'aws-amplify/data';
import type { Schema } from '../../amplify/data/resource';
import { isFreelancerSubscriptionRecord } from './freelancerSubscriptionAccess';
import { isActivePilotFreelancerTrial } from './freelancerPilotAccess';

type DataClient = ReturnType<typeof generateClient<Schema>>;

/**
 * True only for freelancers who have never completed checkout (no therapist-tier UserSubscription row).
 * Cancelled or expired subscribers stay on the org admin dashboard.
 */
export async function freelancerNeedsCheckout(
  client: DataClient,
  userId: string,
  organizationId: string | null | undefined
): Promise<boolean> {
  if (!organizationId) return false;
  try {
    const orgRes = await client.models.Organization.get(
      { id: organizationId },
      { authMode: 'apiKey' }
    );
    if (orgRes.data?.orgType !== 'FREELANCER') return false;

    const userRes = await client.models.User.get({ id: userId }, { authMode: 'apiKey' });
    if (isActivePilotFreelancerTrial(userRes.data)) {
      return false;
    }

    const subsRes = await client.models.UserSubscription.list({
      filter: { userId: { eq: userId } },
      authMode: 'userPool',
    });
    const subs = subsRes.data || [];
    const hasEverSubscribed = subs.some((s) => isFreelancerSubscriptionRecord(s));
    return !hasEverSubscribed;
  } catch {
    return true;
  }
}
